<template>
  <vs-checkbox
      :id="getFieldID(schema)"
      v-model="value"
      :autocomplete="schema.autocomplete"
      :disabled="disabled"
      :name="schema.inputName"
      :class="schema.fieldClasses"
      :required="schema.required"
      v-attributes="'input'"
  />
</template>

<script>
import abstractField from 'vue-form-generator/src/fields/abstractField';

export default {
	mixins: [abstractField],
  methods: {
    formatValueToField(value) {
      return Number(value);
    },
  },
};
</script>

<style lang="scss">
</style>
